<template>
  <section class="cotizar-header">
    <section class="progressbar-mobile">
      <div class="progressbar">
        <div
          v-bind:style="
            progressbar <= 100 ? 'width:' + progressbar + '%' : 'width:100%'
          "
          class="progress"
        >
          asd
        </div>
      </div>
    </section>
    <section class="logo-cotizar">
      <div class="container-fluid mt-3 mb-3">
        <div class="columns is-mobile is-multiline">
          <div class="column is-12-mobile is-4-tablet is-4-desktop">
            <figure class="logo-container">
              <a href="https://www.osfatun.com.ar/" target="_blank">
                <img
                  src="./../../assets/logo-cotizar-header.svg"
                  width="250px"
                  alt="osfatun"
                />
              </a>
            </figure>
            <router-link to="/" class="close-responsive">
              <img
                width="70%"
                src="./../../assets/close-resp.svg"
                alt="cerrar"
              />
            </router-link>
          </div>
          <div
            class="progressbar-desktop column is-10-mobile is-7-tablet is-7-desktop"
          >
            <div class="progressbar">
              <div
                class="progress"
                v-bind:style="
                  progressbar <= 100
                    ? 'width:' + progressbar + '%'
                    : 'width:100%'
                "
              >
                asd
              </div>
            </div>
          </div>
          <div
            class="progressbar-desktop column is-2-mobile is-1-tablet is-1-desktop"
          >
            <router-link :to="'/'">
              <img class="close" src="./../../assets/exit.svg" width="32px" />
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  name: "CotizarHeader",
  props: ["progressbar"],
};
</script>

<style scoped>
.progressbar-mobile {
  display: none;
}
.progressbar {
  width: 100%;
  background-color: rgb(209, 209, 209);
  display: block;
  margin-top: 5%;
}
.progressbar .progress {
  color: transparent;
  background-color: #00738f;
  /* width: 50%; */
  height: 7px;
}
.close {
  display: block;
  margin-top: 20px;
}
.cotizar-header {
  padding: 40px 0;
}
.cotizar-header .logo-container img {
  width: 100%;
}
.cotizar-header .logo-container {
  max-width: 80%;
  margin: 0 auto;
}
.close-responsive {
  display: none;
}
/* res */
@media screen and (max-width: 480px) {
  .progressbar-desktop {
    display: none;
  }
  .progressbar-mobile {
    display: block;
  }
  .progressbar-mobile .progressbar {
    margin-top: 0 !important;
    height: 9px;
    border-radius: 0;
  }
  .cotizar-header {
    padding: 0;
  }
  .logo-cotizar {
    position: relative;
    margin: 30px 0;
  }
  .logo-cotizar .close-responsive {
    display: block;
    position: absolute;
    top: 35%;
    right: 0px;
  }
  .logo-cotizar .logo-container {
    max-width: 60%;
    margin: 0;
    margin-left: 10%;
  }
}
</style>
